import { render, staticRenderFns } from "./VSCodeExtension.vue?vue&type=template&id=03213bce"
import script from "./VSCodeExtension.vue?vue&type=script&lang=js"
export * from "./VSCodeExtension.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports